import usePromotions from "common/datahooks/usePromotions";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

import AgencySubscriptionCard from "../AgencySubscriptionCard";
import Promotions from "./Promotions";
import { LinkedInCrm, Rented } from "./SubscriptionCards";

export default function Overview() {
  const { role } = useSelectedWorkspaceContext();
  const { agencyPlan } = usePromotions();

  return (
    <>
      {role === "owner" && <Promotions />}
      {agencyPlan ? (
        <AgencySubscriptionCard isAgencyPage={false} />
      ) : (
        <LinkedInCrm />
      )}
      <Rented />
    </>
  );
}
